import * as React from "react";
import styled, { css } from "styled-components";
const Marker = styled.span(
  ({ theme }) => css`
    color: ${theme.colors.variant.danger};
    margin-left: ${theme.spacings.xxs};
  `
);
const RequiredMarker = () => /* @__PURE__ */ React.createElement(Marker, { "aria-hidden": "true" }, "*");
export default RequiredMarker;
